<template xmlns="http://www.w3.org/1999/html">
    <b-modal v-model="visible" size="sm">
        <template v-slot:modal-header="{ close }">
            <div class="row" style="width: 100%">
                <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                    <h3> {{ __('import_groups') }} </h3>
                </div>
                <div class="col-md-1">
                    <button type="button" class="close" v-on:click="visible = false">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">{{ __('close') }}</span>
                    </button>
                </div>
            </div>
        </template>

        <template v-slot:default="{}">
            <div>
                <label v-if="analyzeType == 'buy'">
                    <input type="radio" :value="'sell_analyze'" v-model="importFrom"/>
                    {{ __('from_sell_analyze') }}
                </label>
            </div>
            <div>
                <label v-if="analyzeType == 'sell'">
                    <input type="radio" :value="'buy_analyze'" v-model="importFrom"/>
                    {{ __('from_buy_analyze') }}
                </label>
            </div>
            <div v-if="stockEnabled == 1" class="mt-3">
                <label v-if="analyzeType == 'sell'">
                    <input type="radio" :value="'stock'" v-model="importFrom"/>
                    {{ __('from_stock') }}
                </label>
                <select2 v-if="importFrom == 'stock'" :options="stockOptions" v-model="stockId"></select2>
            </div>

        </template>
        <template v-slot:modal-footer="{}">
            <div class="row m-b">
                <div class="col white-space-no-wrap">
                    <button type="button" class="btn btn-white" v-on:click="visible = false">{{__('cancel')}}</button>
                </div>
                <div class="col white-space-no-wrap" v-if="importFrom != 'stock' || (importFrom == 'stock' && stockId != 0 )">
                    <button type="button" class="btn btn-primary" v-on:click="importGroups()">{{__('OK')}}</button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>
export default {
    name: "ModalImportItemGroup",
    data: function () {
        return {
            visible: false,
            importFrom : this.analyzeType == 'sell' ? 'buy_analyze' : 'sell_analyze',
            stockId: 0
        }
    },
    props:{
        analyzeType: {
            type: String
        },
        stockEnabled:{
            type:Number
        },
        stocks:{
            type:Array
        }
    },
    methods:{
        importGroups()  {
            this.$emit('importItemGroups',this.importFrom, this.stockId)
        }
    },
    computed:{
        stockOptions() {
            let options = [];
            options.push({text: '---', 'id': 0})
            for (var i = 0; i <= this.stocks.length - 1; i++) {
                options.push({text: this.stocks[i].name, 'id': this.stocks[i].id})
            }

            return options
        },
    },

}
</script>

<style scoped>

</style>
